import { Routes } from '@angular/router';
import { HealthCheck } from '@core/components/HealthCheck';

export const routes: Routes = [
  {
    path: 'health-check',
    component: HealthCheck,
  },
  {
    path: 'painel',
    loadChildren: () =>
      import('./modules/painel/painel.module').then((m) => m.PainelModule),
  },
  {
    path: '',
    loadChildren: () =>
      import('./modules/utente/utente.module').then((m) => m.UtenteModule),
  },
];
